<script>
    import { t } from '../core/i18n/language-store';
    import {isPaidStore} from "../core/app-store.js";
    export let tenantKey;
</script>

<style>
    .dm-label {
        font-family: Roboto Condensed, sans-serif;
        font-size: 16px;
        color: var(--main-font-color);
        padding: 0 1rem 2rem 1rem;
    }
    .dm-label hr {
        border: none;
        margin-bottom: 2rem;
        border-top: 1px solid rgba(255,255,255, .2);
    }
    .dm-label a {
        color: var(--accent-color);
    }

    @media (min-width: 768px) {
        .dm-label {
            text-align: center;
        }
    }
</style>

{#if !$isPaidStore }
    <div class="dm-label">
        <hr>
        {$t('dmLabel.text')} <a href="https://digital-menu.ru/?utm_source=menu&utm_medium=footer&utm_campaign={tenantKey}">digital-menu.ru</a>
    </div>
{/if}
